define('views/leftnav/Podio.Views.LeftNav.OrgNavOrgList',['require','views/leftnav/Podio.Views.LeftNav.OrgNavOrg','lib/backbone/Backbone.PodioCollectionView'],function(require) {

  var ViewOrgNavOrg = require('views/leftnav/Podio.Views.LeftNav.OrgNavOrg');
  var PodioCollectionView = require('lib/backbone/Backbone.PodioCollectionView');

  return PodioCollectionView.extend({

    initialize: function() {
      this.itemView = ViewOrgNavOrg;

      this.itemViewOptions = function() {
        return {
          eventBus: this.getOption('eventBus'),
          currentOrganization: this.getOption('currentOrganization'),
          collapsedOrganizations: this.getOption('collapsedOrganizations')
        };
      };

      this._super();
    }

  });

});

